<template>
  <div class="section__lk-content container-shadow fill-white">
    <modal-feedback ref="feedbackModal" />
    <div class="section__lk-title">Онлайн программа</div>
    <div v-if="courses.length">
      <div>
        <label class="section__lk-label" for="course"><span>Выберите курс обучения</span></label>
        <v-select :searchable="false" :clearable="false" id="course" :loading="!courses.length" :disabled="!courses.length" label="title" name="course" :options="courses" v-model="course">
          <template slot="option" slot-scope="item">
            <div>{{ item.title }}</div>
            <div class="text-grey">
              <span class="course-cut-date">{{ item.startDateText }}</span>
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.4678 8.39453L8.46555 8.39636L8.46341 8.39844L8.4678 8.39453ZM18.4219 8.208C18.3523 8.14095 18.2751 8.08228 18.1919 8.03319C18.0741 7.96385 17.9433 7.91942 17.8076 7.90263C17.672 7.88585 17.5343 7.89707 17.4031 7.9356C17.272 7.97414 17.1501 8.03916 17.0451 8.12667C16.9401 8.21417 16.8541 8.32229 16.7925 8.44433C16.448 9.12302 15.9729 9.72702 15.3945 10.2217C15.483 9.72328 15.5276 9.21808 15.5278 8.7119C15.5297 7.172 15.1234 5.65911 14.3505 4.32726C13.5775 2.99542 12.4654 1.89219 11.1274 1.1299C10.98 1.04635 10.8138 1.00161 10.6444 0.999886C10.475 0.998162 10.3079 1.03951 10.1588 1.12004C10.0098 1.20058 9.88362 1.31766 9.7922 1.46031C9.70078 1.60296 9.6471 1.76649 9.6362 1.93557C9.58024 2.88374 9.33236 3.81069 8.90759 4.66024C8.48282 5.50979 7.88999 6.26426 7.16503 6.87793L6.93456 7.06543C6.17648 7.57552 5.50546 8.20433 4.94726 8.92773C4.07958 10.0208 3.47851 11.3011 3.19172 12.6669C2.90493 14.0327 2.94031 15.4466 3.29506 16.7964C3.6498 18.1462 4.31415 19.3948 5.23543 20.4431C6.1567 21.4914 7.30956 22.3107 8.60257 22.8359C8.75439 22.898 8.91914 22.9217 9.08229 22.905C9.24545 22.8883 9.40198 22.8317 9.5381 22.7403C9.67422 22.6488 9.78573 22.5252 9.8628 22.3804C9.93987 22.2357 9.98013 22.0742 9.98003 21.9102C9.97932 21.8041 9.96252 21.6987 9.93023 21.5977C9.7065 20.7567 9.64208 19.8813 9.74028 19.0166C10.6865 20.8013 12.2054 22.216 14.0528 23.0332C14.2783 23.1341 14.5332 23.1477 14.7681 23.0713C16.2277 22.6002 17.5425 21.7637 18.5878 20.6413C19.633 19.519 20.3739 18.148 20.74 16.6586C21.1061 15.1692 21.0853 13.611 20.6796 12.1319C20.2739 10.6529 19.4967 9.3021 18.4219 8.208ZM14.5171 21.0391C13.6454 20.5973 12.8765 19.977 12.2603 19.2185C11.6441 18.4601 11.1944 17.5804 10.9405 16.6367C10.8629 16.319 10.8029 15.9972 10.7608 15.6729C10.7322 15.4663 10.6398 15.2738 10.4965 15.1224C10.3532 14.9709 10.1661 14.868 9.96146 14.8281C9.89841 14.8157 9.8343 14.8095 9.77003 14.8096C9.59427 14.8095 9.42161 14.8558 9.26944 14.9437C9.11728 15.0317 8.991 15.1582 8.90333 15.3106C8.0736 16.7417 7.65633 18.3746 7.69776 20.0283C6.968 19.4609 6.35811 18.7544 5.90344 17.9495C5.44876 17.1447 5.15835 16.2576 5.04903 15.3397C4.93971 14.4218 5.01366 13.4914 5.26658 12.6023C5.51951 11.7132 5.94639 10.8831 6.52247 10.1602C6.95989 9.59202 7.48756 9.09947 8.08447 8.70218C8.11032 8.6855 8.1351 8.66723 8.15869 8.64749C8.15869 8.64749 8.45538 8.40201 8.46552 8.39639C9.89022 7.19135 10.9035 5.5719 11.3643 3.7637C12.4538 4.77093 13.1804 6.10973 13.431 7.57221C13.6817 9.03469 13.4425 10.539 12.7505 11.8516C12.6591 12.0267 12.6216 12.225 12.6427 12.4215C12.6639 12.6179 12.7427 12.8037 12.8693 12.9554C12.9959 13.1071 13.1646 13.2178 13.3541 13.2738C13.5436 13.3297 13.7454 13.3282 13.9341 13.2696C15.4659 12.7894 16.8138 11.8515 17.7964 10.5821C18.3869 11.4544 18.773 12.4487 18.9259 13.4909C19.0787 14.5332 18.9944 15.5965 18.6792 16.6016C18.364 17.6068 17.826 18.5278 17.1054 19.2961C16.3847 20.0644 15.5 20.6602 14.5171 21.0391L14.5171 21.0391Z"/>
                </svg>
              </span>
              Активен
            </div>
          </template>
        </v-select>
        <div class="section__lk-under-label">
          <div class="section__lk-under-label-time">
            <img class="icon" src="/pic/calendar.svg" alt="icon-clock" />
            Вы приступили к обучению {{ course.enrollDatetime | formatDate('DD') }} {{ course.enrollDatetime | formatDate('M') }} {{ course.enrollDatetime | formatDate('YYYY') }}
          </div>
          <div class="section__lk-under-label-separator d-none d-lg-block d-md-block"></div>
          <div class="section__lk-under-label-link">
            <router-link :to="'/education/start-eksportnoy-deyatelnosti-10-shagov-k-uspehu/' + course.alias">Подробнее о курсе</router-link>
          </div>
          <div class="section__lk-under-label-link" id="tooltip" :style="{display: isTestAccess ? 'flex!important' : 'none!important'}">
            <div class="section__lk-under-label-separator d-none d-lg-block d-md-block"></div>
            <a v-if="participant" href="javascript:void(0)" @click.prevent="handleTestClick">Итоговый тест по программе</a>
            <div class="ml-1">
              <img src="/pic/profile/red-question.svg" class="object-fit-cover"/>
            </div>
          </div>
        </div>
        <div class="section__lk-text" v-html="course.fullDesc"></div>
      </div>
      <div class="mt-6" v-if="module && module.title">
        <label class="section__lk-label" for="course"><span>Выберите модуль</span></label>
        <v-select
            ref="moduleSelect"
            class="v-select-centered module-select"
            :class="{'module-select_drop-up': moduleSelectDropUp}"
            :max-height="moduleSelectMaxHeight"
            :searchable="false"
            :clearable="false"
            id="course"
            :loading="!modules.length"
            :disabled="!modules.length"
            label="title"
            name="course"
            :options="modules"
            v-model="module"
            @mousedown.native.capture="updateModuleSelectDropdown"
            @touchstart.native.capture="updateModuleSelectDropdown"
            @search:focus="updateModuleSelectDropdown">
          <template v-slot:selected-option="module">
            <span class="selected-option-type">Модуль {{module.index}}:</span>
            {{ module.title }}
          </template>
          <template v-slot:option="module">
            <span class="selected-type">Модуль {{module.index}}:</span>
            <div>{{ module.title }}</div>
            <div class="text-grey">
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.4678 8.39453L8.46555 8.39636L8.46341 8.39844L8.4678 8.39453ZM18.4219 8.208C18.3523 8.14095 18.2751 8.08228 18.1919 8.03319C18.0741 7.96385 17.9433 7.91942 17.8076 7.90263C17.672 7.88585 17.5343 7.89707 17.4031 7.9356C17.272 7.97414 17.1501 8.03916 17.0451 8.12667C16.9401 8.21417 16.8541 8.32229 16.7925 8.44433C16.448 9.12302 15.9729 9.72702 15.3945 10.2217C15.483 9.72328 15.5276 9.21808 15.5278 8.7119C15.5297 7.172 15.1234 5.65911 14.3505 4.32726C13.5775 2.99542 12.4654 1.89219 11.1274 1.1299C10.98 1.04635 10.8138 1.00161 10.6444 0.999886C10.475 0.998162 10.3079 1.03951 10.1588 1.12004C10.0098 1.20058 9.88362 1.31766 9.7922 1.46031C9.70078 1.60296 9.6471 1.76649 9.6362 1.93557C9.58024 2.88374 9.33236 3.81069 8.90759 4.66024C8.48282 5.50979 7.88999 6.26426 7.16503 6.87793L6.93456 7.06543C6.17648 7.57552 5.50546 8.20433 4.94726 8.92773C4.07958 10.0208 3.47851 11.3011 3.19172 12.6669C2.90493 14.0327 2.94031 15.4466 3.29506 16.7964C3.6498 18.1462 4.31415 19.3948 5.23543 20.4431C6.1567 21.4914 7.30956 22.3107 8.60257 22.8359C8.75439 22.898 8.91914 22.9217 9.08229 22.905C9.24545 22.8883 9.40198 22.8317 9.5381 22.7403C9.67422 22.6488 9.78573 22.5252 9.8628 22.3804C9.93987 22.2357 9.98013 22.0742 9.98003 21.9102C9.97932 21.8041 9.96252 21.6987 9.93023 21.5977C9.7065 20.7567 9.64208 19.8813 9.74028 19.0166C10.6865 20.8013 12.2054 22.216 14.0528 23.0332C14.2783 23.1341 14.5332 23.1477 14.7681 23.0713C16.2277 22.6002 17.5425 21.7637 18.5878 20.6413C19.633 19.519 20.3739 18.148 20.74 16.6586C21.1061 15.1692 21.0853 13.611 20.6796 12.1319C20.2739 10.6529 19.4967 9.3021 18.4219 8.208ZM14.5171 21.0391C13.6454 20.5973 12.8765 19.977 12.2603 19.2185C11.6441 18.4601 11.1944 17.5804 10.9405 16.6367C10.8629 16.319 10.8029 15.9972 10.7608 15.6729C10.7322 15.4663 10.6398 15.2738 10.4965 15.1224C10.3532 14.9709 10.1661 14.868 9.96146 14.8281C9.89841 14.8157 9.8343 14.8095 9.77003 14.8096C9.59427 14.8095 9.42161 14.8558 9.26944 14.9437C9.11728 15.0317 8.991 15.1582 8.90333 15.3106C8.0736 16.7417 7.65633 18.3746 7.69776 20.0283C6.968 19.4609 6.35811 18.7544 5.90344 17.9495C5.44876 17.1447 5.15835 16.2576 5.04903 15.3397C4.93971 14.4218 5.01366 13.4914 5.26658 12.6023C5.51951 11.7132 5.94639 10.8831 6.52247 10.1602C6.95989 9.59202 7.48756 9.09947 8.08447 8.70218C8.11032 8.6855 8.1351 8.66723 8.15869 8.64749C8.15869 8.64749 8.45538 8.40201 8.46552 8.39639C9.89022 7.19135 10.9035 5.5719 11.3643 3.7637C12.4538 4.77093 13.1804 6.10973 13.431 7.57221C13.6817 9.03469 13.4425 10.539 12.7505 11.8516C12.6591 12.0267 12.6216 12.225 12.6427 12.4215C12.6639 12.6179 12.7427 12.8037 12.8693 12.9554C12.9959 13.1071 13.1646 13.2178 13.3541 13.2738C13.5436 13.3297 13.7454 13.3282 13.9341 13.2696C15.4659 12.7894 16.8138 11.8515 17.7964 10.5821C18.3869 11.4544 18.773 12.4487 18.9259 13.4909C19.0787 14.5332 18.9944 15.5965 18.6792 16.6016C18.364 17.6068 17.826 18.5278 17.1054 19.2961C16.3847 20.0644 15.5 20.6602 14.5171 21.0391L14.5171 21.0391Z"/>
                </svg>
              </span>
              Активен
            </div>
          </template>
        </v-select>
      </div>
    </div>
    <div v-else-if="firstLoad" class="section__lk-empty">у вас нет доступа к онлайн-обучению</div>
    <div class="section__lk-content-items" v-if="results && results.length">
      <template  v-for="(chunk) in results">
        <template v-for="(result, index) in chunk">
          <online-row-video :course="course" :module="module" :key="index" v-if="result.type === 'video'" :result="result"  />
          <online-row-tutorial :id="result.data.id" :key="index" v-else-if="result.type === 'tutorial'" :result="result"  />
          <online-row-test :key="index" v-else-if="result.type === 'test'" :result="result"  />
          <online-row-tutorial :id="result.data.id" :key="index" v-else-if="result.type === 'attach'" :result="result"  />
        </template>
      </template>
    </div>
  </div>
</template>

<script>

import tippy from "tippy.js";
import ApiService from "../../../../services/api.service";
import OnlineRowVideo from "@/components/profile/online/OnlineRowVideo.vue";
import OnlineRowTutorial from "@/components/profile/online/OnlineRowTutorial.vue";
import OnlineRowTest from "@/components/profile/online/OnlineRowTest.vue";
import ModalFeedback from "@/components/modal/ModalFeedback.vue";

export default {
  name: "Seminars",
  components: {OnlineRowTest, OnlineRowTutorial, OnlineRowVideo, ModalFeedback},
  data() {
    return {
      courses: [],
      enrolls: [],
      course: null,
      module: null,
      modules: [],
      results: [],
      firstLoad: false,
      schedules: {},
      participant: null,
      pdf: {},
      moduleSelectDropUp: false,
      moduleSelectMaxHeight: '360px'
    }
  },
  async mounted() {
    window.addEventListener('resize', this.updateModuleSelectDropdown)

    this.enrolls = (await ApiService.get('enrollments')).data
    if(this.enrolls.length) {
      this.enrolls.forEach(enroll => {
        this.courses.push({
          ...enroll.course, 
          enrollDatetime: enroll.enrollDatetime,
          program: enroll.program // Сохраняем program из enroll
        })
      })
      this.course = this.courses ? this.courses[0] : null
    }
    this.firstLoad = true
    await this.loadParticipant()
    setTimeout(() => {
      if(this.participant && this.participant.program) {
        tippy('#tooltip', {
          content: 'Итоговый тест по онлайн программе «' + this.participant.program.title + '»',
        });
      }
    }, 500)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateModuleSelectDropdown)
  },
  watch: {
    async course(val) {
      if(val) {
        this.modules = (await ApiService.get('courses/' + val.id + '/modules')).data
        this.schedules = (await ApiService.get('/schedules/' + val.id)).data
        this.module = this.getFirstModuleWithSchedule() || (this.modules.length ? this.modules[0] : {index: 1, title: false});
        // Загружаем participant при изменении курса
        await this.loadParticipant()
      }
    },
    async module(val) {
      if(val == null || val.index == null) {
        return;
      }
      this.results = []

      this.results = this.getScheduleItems(val)
    }
  },
  computed: {
    isTestAccess() {
      return this.participant && this.participant.is_test_access
    }
  },
  methods: {
    updateModuleSelectDropdown() {
      this.$nextTick(() => {
        const select = this.$refs.moduleSelect
        const selectEl = select && select.$el ? select.$el : null

        if(!selectEl) {
          return
        }

        const rect = selectEl.getBoundingClientRect()
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight
        const gap = 24
        const preferredHeight = Math.min(360, Math.round(viewportHeight * 0.45))
        const comfortableHeight = Math.min(280, preferredHeight)
        const spaceBelow = Math.max(0, viewportHeight - rect.bottom - gap)
        const spaceAbove = Math.max(0, rect.top - gap)

        this.moduleSelectDropUp = spaceBelow < comfortableHeight && spaceAbove > spaceBelow

        const availableSpace = this.moduleSelectDropUp ? spaceAbove : spaceBelow
        const maxHeight = Math.max(120, Math.min(preferredHeight, availableSpace || preferredHeight))
        this.moduleSelectMaxHeight = `${Math.floor(maxHeight)}px`
      })
    },
    getScheduleItems(module) {
      const schedules = this.getModuleSchedules(module)
      const results = []

      schedules.forEach(schedule => {
        if(schedule && schedule.archived && typeof schedule.archived === 'object' && Object.values(schedule.archived).length) {
          results.push(...Object.values(schedule.archived))
        }

        if(schedule && schedule.active && typeof schedule.active === 'object' && Object.values(schedule.active).length) {
          results.push(...Object.values(schedule.active))
        }
      })

      return results
    },
    getModuleSchedules(module) {
      const scheduleKeys = this.getModuleScheduleKeys(module)

      return scheduleKeys
          .map(key => this.schedules && this.schedules[key] ? this.schedules[key] : null)
          .filter(schedule => schedule && this.hasScheduleItems(schedule))
          .slice(0, 1)
    },
    getModuleScheduleKeys(module) {
      if(!module) {
        return []
      }

      const keys = []

      if(module.index != null) {
        keys.push(module.index)
      }

      const modulePosition = this.modules.findIndex(item => item && item.id === module.id)

      if(modulePosition > -1) {
        keys.push(modulePosition + 1)
      }

      return [...new Set(keys.map(key => String(key)))]
    },
    hasScheduleItems(schedule) {
      return Boolean(
          schedule &&
          (
              (schedule.archived && typeof schedule.archived === 'object' && Object.values(schedule.archived).length) ||
              (schedule.active && typeof schedule.active === 'object' && Object.values(schedule.active).length)
          )
      )
    },
    getFirstModuleWithSchedule() {
      return this.modules.find(module => {
        return module && module.index && this.getScheduleItems(module).length
      })
    },
    async loadParticipant() {
      if (!this.course || !this.course.program || !this.course.program.id) {
        return;
      }
      
      try {
        this.participant = (await ApiService.get('programparticipant', {
          params: {
            program: this.course.program.id
          }
        })).data
      } catch (error) {
        console.error('Ошибка при загрузке programparticipant:', error);
      }
    },
    async handleTestClick() {

      if (!this.participant || !this.participant.program || !this.participant.program.test) {
        return;
      }

      //TODO: убрать проверку программы
      if(this.participant.program.id === 3) {
        this.$router.push('/lk/test/' + this.participant.program.test.id);
        return;
      }

      try {
        // Проверяем наличие feedback-формы
        const feedbackResponse = await ApiService.get('/formcategories/feedback');
        const feedbackData = feedbackResponse.data;

        // Проверяем наличие поля status с любым текстом
        const hasStatus = feedbackData && feedbackData.status && typeof feedbackData.status === 'string' && feedbackData.status.trim().length > 0;

        if (!hasStatus) {
          // Показываем модальное окно с просьбой оставить обратную связь
          this.$refs.feedbackModal.show();
        } else {
          // Если обратная связь оставлена, переходим к тесту
          this.$router.push('/lk/test/' + this.participant.program.test.id);
        }
      } catch (error) {
        // В случае ошибки при запросе показываем модальное окно
        console.error('Ошибка при проверке feedback-формы:', error);
        this.$refs.feedbackModal.show();
      }
    }
  }
}
</script>

<style lang="scss">
.module-select {
  .dropdown-menu,
  .vs__dropdown-menu {
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  &_drop-up {
    .dropdown-menu,
    .vs__dropdown-menu {
      top: auto !important;
      bottom: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 1.2rem !important;
    }
  }
}
</style>
